import styled from "styled-components";

import WrapperContainer from "../../../Containers/WrapperContainer";
import { Heading6 } from "../../../Text/Headings";
import { Paragraph2 } from "../../../Text/Paragraphs";
import { Button } from "../../../Buttons/styled";

export const TableExampleWrapper = styled(WrapperContainer)`
  background: rgba(52, 48, 61, 0.1);
  border-radius: 8px;
  padding: 16px;

  ${Heading6}, ${Paragraph2} {
    font-size: 14px;
    line-height: 30px;
  }

  ${Paragraph2} {
    line-height: 24px;
    width: 55%;
  }

  ${Button} {
    height: 40px;
    width: fit-content;
    padding: 0 24px;
  }
`;
